import { toast } from "react-toastify";
import jwtDecode from "jwt-decode";

const initialState = {
  token: localStorage.getItem("token"),
  nom: null,  
  rol: null,
  id: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SIGN_IN":
    case "SIGN_UP":
    case "USER_LOADED":
      toast("Welcome...", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      const user = jwtDecode(action.token); 
      //console.log("user decode ==== ",action.token)
      return {
        ...initialState,
        token: action.token,
        nom: user.nom,
        rol: user.rol,
        id: user.id,
      };
    case "SIGN_OUT":
      localStorage.removeItem("token");
      toast("Goodbye...", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return {
        token: null,
        nom: null,
        rol: null,
        id: null,
      };
    default:
      return state;
  }
};

export default authReducer;
